import React, { useState } from 'react';

import { getTeamData, getTeamProps, isCC, isJson, isNCAA, isNCAAAllSports, isOSULacrosse, isTA } from '../../helpers';
import { ALL_SEASON_YEAR, FILTER_KEYS, LEAGUES, POSITION_LACROSSE, SIMPLE_LEAGUE } from '../../config/constants';
import TeamSelector from '../Shared/Filters/TeamsSelector';
import PositionFilter from '../Shared/Filters/PositionFilter';
import PositionLacrosseFilter from '../Shared/Filters/PositionLacrosseFilter';
import { YearSeasonFilter } from '../Shared/Filters/YearSeasonFilter/YearSeasonFilter';
import SimpleSelector from '../Shared/Filters/SimpleSelector';
import { useFiltersState, useUserState } from '../../store/hooks';
import { useRouter } from '../../helpers/customHooks';
import { history } from '../../store/reducers';
import { TeamData } from '../../config/commonTypes';

export default () => {
  
  const user = useUserState();
  const { specificScope, search, pathname } = useRouter();
  const { [FILTER_KEYS.TEAM_ID]: teamIdSelected = user.teamId ,
          [FILTER_KEYS.DATE_RANGE]: year} = useFiltersState(specificScope, FILTER_KEYS.TEAM_ID, FILTER_KEYS.DATE_RANGE);
  const [showFilter, setShowFilter] = useState(-1);
  const teamData = getTeamProps(teamIdSelected) || {} as TeamData;
  const filterSeasonData = new URLSearchParams(location.search).get('defaultyear') || '';
  const defaultYear = year?.year;
  const close = () => setShowFilter(-1);
  
  return (
    <div className="head-filters-01 team-ff">
      {isCC(user) && (
        <SimpleSelector
          show={showFilter === 1}
          close={close}
          open={() => setShowFilter(1)}
          type={SIMPLE_LEAGUE}
          urlPersistent
        />
      )}
      {((user.league === LEAGUES.MLAX && !isTA(user)) || (user.league !== LEAGUES.MLAX && user.league !== LEAGUES.NCAA)) && (
        <TeamSelector
          show={showFilter === 2}
          close={close}
          open={() => setShowFilter(2)}
          urlPersistent
          onApply={(nextTeam, prevTeam) => {
            const teamA = getTeamData(nextTeam);
            const teamB = getTeamData(prevTeam);
            if (teamB && teamA && teamB.isNCAA !== teamA.isNCAA) {
              const urlSearchParams = new URLSearchParams(search);
              urlSearchParams.delete(FILTER_KEYS.DATE_RANGE);
              urlSearchParams.set(FILTER_KEYS.TEAM_ID, nextTeam);
              history.push({ pathname: pathname, search: `?${urlSearchParams.toString()}` });
            }
          }}
        />
      )}
      <YearSeasonFilter
        show={showFilter === 5}
        close={close}
        open={() => setShowFilter(5)}
        onlySeasonWeeks={!('' + user.teamId === '' + teamIdSelected) && !isCC(user)}
        isNcaa={isNCAAAllSports(user) || isNCAA(user) || (isCC(user) && (teamData.league === LEAGUES.MLAX || teamData.league === LEAGUES.NCAA))}
        defaultYear={filterSeasonData? Number(filterSeasonData) : defaultYear? Number(defaultYear) : undefined}
        urlPersistent
      />
      {isOSULacrosse(teamIdSelected) ?
        <PositionLacrosseFilter
          type={POSITION_LACROSSE}
          show={showFilter === 4}
          close={close}
          open={() => setShowFilter(4)}
        /> :
        <PositionFilter
          show={showFilter === 3}
          close={close}
          open={() => setShowFilter(3)}
        />
      }
    </div>
  );
};
